module.exports = __webpack_public_path__ + "static/media/placeholder.c83aa10e.png";